/**
 * PDI Loyalty International API v1.5.20
 * Note: All dates/times returned via API call will be UTC / Accept-Encoding: gzip, deflate<br><br><a href='https://pditechnologies.com/engage-customers/loyalty-marketing-solutions/'>PDI Technologies website</a><br><a href='mailto:azpiral-info@pditechnologies.com?subject=AzpiralAPI'>Send an email to PDI Technologies</a><br><a href='../../Contents/FlowDiagrams/Index.htm'>Flow Diagrams</a><br><a href='../../v1/Helpers/ApiErrors/'>Error Codes</a>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The GiftCardBalResponse model module.
 * @module model/GiftCardBalResponse
 * @version v1
 */
class GiftCardBalResponse {
    /**
     * Constructs a new <code>GiftCardBalResponse</code>.
     * @alias module:model/GiftCardBalResponse
     * @param giftCardNum {String} 
     * @param amount {Number} 
     */
    constructor(giftCardNum, amount) { 
        
        GiftCardBalResponse.initialize(this, giftCardNum, amount);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, giftCardNum, amount) { 
        obj['GiftCardNum'] = giftCardNum;
        obj['Amount'] = amount;
    }

    /**
     * Constructs a <code>GiftCardBalResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GiftCardBalResponse} obj Optional instance to populate.
     * @return {module:model/GiftCardBalResponse} The populated <code>GiftCardBalResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GiftCardBalResponse();

            if (data.hasOwnProperty('GiftCardNum')) {
                obj['GiftCardNum'] = ApiClient.convertToType(data['GiftCardNum'], 'String');
            }
            if (data.hasOwnProperty('Amount')) {
                obj['Amount'] = ApiClient.convertToType(data['Amount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GiftCardBalResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GiftCardBalResponse</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of GiftCardBalResponse.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['GiftCardNum'] && !(typeof data['GiftCardNum'] === 'string' || data['GiftCardNum'] instanceof String)) {
            throw new Error("Expected the field `GiftCardNum` to be a primitive type in the JSON string but got " + data['GiftCardNum']);
        }

        return true;
    }


}

GiftCardBalResponse.RequiredProperties = ["GiftCardNum", "Amount"];

/**
 * @member {String} GiftCardNum
 */
GiftCardBalResponse.prototype['GiftCardNum'] = undefined;

/**
 * @member {Number} Amount
 */
GiftCardBalResponse.prototype['Amount'] = undefined;






export default GiftCardBalResponse;

